import { Component, OnInit, ViewChild, Inject, ElementRef, PLATFORM_ID, HostListener, NgZone } from '@angular/core';
import { Router, NavigationEnd, ActivationEnd } from '@angular/router';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { CustomValidator } from './../../_common/custom-validators';
import { Validators, FormControl, UntypedFormBuilder, FormGroup } from '@angular/forms';
import { CommonService } from '../../services/common.service';
import { Subscription } from 'rxjs';
import { ApiService } from '../../services/api-data.service';
import { URLS } from '../../_config/api.config';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'app-resources-slider',
    templateUrl: './resources-slider.component.html',
    styleUrls: ['./resources-slider.component.scss'],
})
export class ResourcesSliderComponent implements OnInit {

    private subscription: Subscription = new Subscription();
    public title: any;
    public isLoading = false;
    articleLoading=false;
    videoData: any;
    articleData: any;
    testimonailData: any;
    videoUrl: any;
    youTubeUrl: any;
    isVideoYoutubeUrl: boolean = false;
    noVideo: boolean = false;
    noArticle: boolean = false;
    noTestimonial: boolean = false;
    isTestimonialLoading=true;
    stars = [1, 2, 3, 4, 5];
    carouselSub!: Subscription;

    carouselReady: boolean = false;

    customOptions: OwlOptions = {
        loop: false,
        mouseDrag: false,
        touchDrag: true,
        pullDrag: false,
        dots: true,
        navSpeed: 700,
        navText: ['<img src="../../../assets/images/left-orange-arrow.webp">', '<img src="../../../assets/images/right-orange-arrow.webp">'],
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 2
            },
            1024: {
                items: 3
            },
            1200: {
                items: 3
            },
            1350: {
                items: 4
            }
        },
        nav: true
    }

    customOptionsArticles: OwlOptions = {
        loop: false,
        margin: 20, // Spacing between items
        mouseDrag: true,
        touchDrag: true,
        pullDrag: false,
        dots: true,
        navSpeed: 700,
        navText: [
            '<img src="../../../assets/images/left-orange-arrow.webp">',
            '<img src="../../../assets/images/right-orange-arrow.webp">'
        ],
        stagePadding: 15, // Adds padding on sides
        responsive: {
            0: {
                items: 1,
                stagePadding: 10
            },
            600: {
                items: 2,
                stagePadding: 15
            },
            1024: {
                items: 3,
                // stagePadding: 30
            }
        },
        nav: true
    };

    customOptions2: OwlOptions = {
        loop: false,
        mouseDrag: false,
        touchDrag: true,
        pullDrag: false,
        dots: true,
        navSpeed: 700,
        navText: ['<img src="../../../assets/images/left-orange-arrow.webp">', '<img src="../../../assets/images/right-orange-arrow.webp">'],
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 1
            },
            1024: {
                items: 2
            },
            1200: {
                items: 2
            },
            1350: {
                items: 2
            }
        },
        nav: true
    }

    constructor(
        private router: Router,
        private datePipe: DatePipe,
        private commonService: CommonService,
        private dataService: ApiService,
        private toastr: ToastrService,
        private formBuilder: UntypedFormBuilder,
        @Inject(DOCUMENT) private document: Document,
        private sanitize: DomSanitizer,
        @Inject(PLATFORM_ID) private platformId: Object,
       private ngZone: NgZone
    ) { }

    ngOnInit() {
        if (isPlatformBrowser(this.platformId)) {
            const offset = this.document.documentElement.scrollTop || this.document.body.scrollTop || 0;
            if (offset != 0) {
                this.document.getElementsByTagName("body")[0].style.overflowY = "auto";
            }

            this.getVideo();
            this.getArticle();
            this.getTestimonail();

            setTimeout(() => {
                this.carouselReady = true;
            }, 2000); // Adjust the delay time as needed
        }

        if (isPlatformBrowser(this.platformId)) {
            setInterval(() => {
                if (!this.carouselItems || this.carouselItems.length === 0) return;
                this.currentIndex = (this.currentIndex + 1) % this.carouselItems.length;
            }, 5000);
        }
    }

    getVideo() {
        const params = {
            isActive: true
        }
        this.subscription.add(
            this.dataService.get(URLS.getVideo, params).subscribe(data => {
                if (data['code'] == 200) {
                    this.videoData = data['data']['result'];
                    if (data['data']['result'].length <= 0) {
                        this.noVideo = true;
                    } else {
                        this.noVideo = false;
                    }
                } else {
                    this.toastr.error(data['message'], "Error");
                }
            }, error => {
                this.toastr.error(error['message'], "Error");
            })
        )
    }

    getArticle() {
        this.subscription.add(
            this.dataService.get(URLS.getArticle).subscribe(data => {
                if (data['code'] == 200) {
                    this.articleData = data['data']['result'];
                    if (data['data']['result'].length <= 0) {
                        this.noArticle = true;
                    } else {
                        this.noArticle = false;
                    }
                } else {
                    this.toastr.error(data['message'], "Error");
                }
            }, error => {
                this.toastr.error(error['message'], "Error");
            })
        )
    }
    getTestimonail() {
        const params = {
            isActive: true
        }
        this.subscription.add(
            this.dataService.get(URLS.getHomeTestimonail, params).subscribe(data => {
                if (data['code'] == 200) {
                    this.testimonailData = data['data']['result'];
                    if (data['data']['result'].length <= 0) {
                        this.noTestimonial = true;
                    } else {
                        this.noTestimonial = false;
                    }
                } else {
                    this.toastr.error(data['message'], "Error");
                }
            }, error => {
                this.toastr.error(error['message'], "Error");
            })
        )
    }

    openVideo(data) {

        this.videoUrl = '';
        this.youTubeUrl = '';

        if (data.url) {
            if (data.url && data.url.includes('www.youtube.com')) {
                this.isVideoYoutubeUrl = true;
                if (data.url.includes('https://www.youtube.com/watch?v=')) {
                    data.url = data.url.replace("https://www.youtube.com/watch?v=", "https://www.youtube.com/embed/")
                }
                this.youTubeUrl = this.sanitize.bypassSecurityTrustResourceUrl(data.url);

            } else {
                this.isVideoYoutubeUrl = false;
                this.videoUrl = this.sanitize.bypassSecurityTrustResourceUrl(data.url);
            }
        } else {
            this.videoUrl = this.sanitize.bypassSecurityTrustResourceUrl(data.s3FileKey);
        }

        this.subscription.add(
            this.dataService.put(URLS.updateVideo + '?_id=' + data._id).subscribe(data => {
                if (data['code'] == 200) {

                } else {
                    this.toastr.error(data['message'], "Error");
                }
            }, error => {
                this.toastr.error(error['message'], "Error");
            })
        )
    }

    closeVideoModal() {
        this.videoUrl = '';
        this.youTubeUrl = '';
        this.isVideoYoutubeUrl = false;
    }


    currentIndex = 0;

    prevSlide() {
        if (this.currentIndex > 0) {
            this.currentIndex--;
        }
    }

    nextSlide() {
        if (this.currentIndex < this.articleData.length - 1) {
            this.currentIndex++;
        }
    }

    contactUs() {
        this.router.navigateByUrl('/contact-us');
    }

    removeHtmlTags(input: string): string {
        if (typeof input !== 'string') {
          return ''; // Handle non-string input
        }
    
        const matches = [...input.matchAll(/<p[^>]*>([\s\S]*?)<\/p>/gi)];
        let firstPContent = matches.length > 0 ? matches[0][1] : '';
        input=input.replace(firstPContent, '');
        firstPContent=firstPContent.replace(/<\/?[^>]+(>|$)/g, '')
        firstPContent=firstPContent.replace(/&nbsp;/g, '');

        // Remove HTML tags
        let text = input.replace(/<\/?[^>]+(>|$)/g, '');
        text= text.replace(/&nbsp;/g,'');
    
        // Decode HTML entities
        if (isPlatformBrowser(this.platformId)) {
            const textarea = document.createElement("textarea");
            textarea.innerHTML = firstPContent+text;
            return textarea.value;
        }
      }


      readMore(data) {
        if (data.authorName) {
          // const formattedTitle = data.title.replace(/\s+/g, '-');
        //   const formattedTitle = data.title.replace(/\?/g, '').replace(/\s+/g, '-');  
          const formattedTitle = data.title.replace(/[^a-zA-Z0-9- ]/g, '').replace(/\s+/g, '-');  
          this.router.navigate(['articles/', formattedTitle.toLowerCase()]);
        }
        else
        window.open(data.url, '_blank');
      } 

    redirectToArticle(){
        this.router.navigate(['articles']);
    }

    
getCardClass(i: number) {
    const total = this.carouselItems.length;
    if (total === 1) {
      // Only one card — always center
      return 'tcarousel-1-center';
    }
    if (total === 2) {
      // Special-case: avoid both left and right pointing to same index.
      // Make currentIndex the center; the other card will be shown on a single side.
      if (i === this.currentIndex) return 'tcarousel-1-center';
      // Alternate which side the other card sits on to make the animation feel natural:
      // when currentIndex is even show the other card on the right, when odd show it on the left.
      return (this.currentIndex % 2 === 0) ? 'tcarousel-1-right' : 'tcarousel-1-left';
    }
    // Default behavior for 3+ items (unchanged)
    if (i === this.currentIndex) return 'tcarousel-1-center';
    if (i === (this.currentIndex - 1 + total) % total) return 'tcarousel-1-left';
    if (i === (this.currentIndex + 1) % total) return 'tcarousel-1-right';
    return 'tcarousel-1-hidden';
  }
  get carouselItems() {
    if (!this.testimonailData) return [];
    if (this.testimonailData.length >= 3) {
      return this.testimonailData;
    }
    // Duplicate items until length = 3
    const extended = [...this.testimonailData];
    while (extended.length < 3) {
      extended.push(...this.testimonailData); // repeat
    }
    return extended.slice(0, 3); // ensure exactly 3
  }
    
}
